import AuthLayout from "@/ui/components/auth/AuthLayout";
import RecoverForm from "@/ui/components/auth/RecoverForm";

export default function Recover() {
  return (
    <AuthLayout
      title="Recuperar senha"
      subtitle="Vamos ajudá-lo a recuperar o acesso à sua conta"
    >
      <RecoverForm />
    </AuthLayout>
  );
}
